import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import Modal from 'react-modal';
import { create } from 'xmlbuilder2';
import "../Reports.css";

Modal.setAppElement('#root');

function WorkedHoursReport() {
    const [agentId, setAgentId] = useState("");
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/workedHours/${agentId}`);
            setReportData({ agentId, hours: response.data });
        } catch (error) {
            if (error.response && [500, 404, 400].includes(error.response.status)) {
                setModalIsOpen(true);
            } else {
                console.error("Ошибка при получении данных:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по количеству отработанных часов агента",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({
                            text: `Идентификатор агента: ${reportData.agentId}`,
                        }),
                        new Paragraph({
                            text: `Отработанные часы: ${reportData.hours} часов`,
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "worked_hours_report.docx");
        });
    };

    const generateXmlDocument = () => {
        const xml = create({ version: '1.0', encoding: 'UTF-8' })
            .ele('WorkedHoursReport')
            .ele('AgentId').txt(reportData.agentId).up()
            .ele('Hours').txt(reportData.hours.toString()).up()
            .end({ prettyPrint: true });

        const blob = new Blob([xml], { type: 'application/xml' });
        saveAs(blob, "worked_hours_report.xml");
    };

    return (
        <div className="otch-report-card">
            <h2>💰 Расчет зарплаты агента</h2>

            <div className="otch-form-group">
                <input
                    type="text"
                    placeholder="Введите идентификатор агента"
                    value={agentId}
                    onChange={(e) => setAgentId(e.target.value)}
                    className="otch-form-input"
                    style={{ width: '100%' }}
                />
            </div>

            {reportData && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Агент <span className="otch-highlight">{reportData.agentId}</span>
                        <br />
                        Отработал часов: <span className="otch-highlight">{reportData.hours}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading || !agentId.trim()}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Расчет...
                        </>
                    ) : (
                        "🧮 Рассчитать часы"
                    )}
                </button>
                {reportData && (
                    <>
                        <button
                            onClick={generateWordDocument}
                            className="otch-button otch-word-download-btn"
                        >
                            📝 Word
                        </button>
                        <button
                            onClick={generateXmlDocument}
                            className="otch-button otch-xml-download-btn"
                        >
                            📄 XML
                        </button>
                    </>
                )}
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Ошибка сервера"
                className="otch-modal"
                overlayClassName="otch-modal-overlay"
            >
                <h2 className="otch-modal-title">⚠️ Ошибка</h2>
                <p className="otch-modal-message">Проверьте правильность введенного идентификатора агента.</p>
                <button
                    onClick={() => setModalIsOpen(false)}
                    className="otch-modal-button"
                >
                    Понятно
                </button>
            </Modal>
        </div>
    );
}

export default WorkedHoursReport;